import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { masterApi, ALL_UNITS } from '../lib/api';

const UnitContext = createContext();

export function UnitProvider({ children }) {
  const { user } = useAuth();
  const [activeUnit, setActiveUnitState] = useState(() => localStorage.getItem('activeUnit') || null);
  const [allowedUnits, setAllowedUnits] = useState([]);
  const canSwitch = user?.role === 'admin' || user?.perm_scope === 'all';
  const isAllUnits = activeUnit === ALL_UNITS;

  const setActiveUnit = (u) => {
    setActiveUnitState(u);
    if (u) localStorage.setItem('activeUnit', u);
    else localStorage.removeItem('activeUnit');
  };

  useEffect(() => {
    if (!user) return;
    if (canSwitch) {
      masterApi.units()
        .then((res) => setAllowedUnits([ALL_UNITS, ...res.data.map((u) => u.name)]))
        .catch(() => setAllowedUnits([ALL_UNITS]));
    } else if (user.unit) {
      setAllowedUnits([user.unit]);
      setActiveUnit(user.unit); // locked users are pinned to their own unit
    }
    // eslint-disable-next-line
  }, [user]);

  // Safety: a locked user must never sit in All Units mode (e.g. stale
  // localStorage from a previous admin login on the same browser).
  useEffect(() => {
    if (user && !canSwitch && activeUnit === ALL_UNITS) {
      setActiveUnit(user.unit || null);
    }
    // eslint-disable-next-line
  }, [user, canSwitch, activeUnit]);

  return (
    <UnitContext.Provider value={{ activeUnit, setActiveUnit, allowedUnits, canSwitch, isAllUnits }}>
      {children}
    </UnitContext.Provider>
  );
}

export function useUnit() {
  const ctx = useContext(UnitContext);
  if (!ctx) throw new Error('useUnit must be used within UnitProvider');
  return ctx;
}
